import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import { useAlert } from "../../../../Context/AlertContext";
import useToastError from "../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import TableData from "../../../../Components/Common/TableData";
import { modelTestUrls } from "../../../../Api/Auth/ApiUrls";
import {
  sendDeleteRequestAuth,
  sendPutRequestAuth,
} from "../../../../Api/swrConfig";
import { toast } from "react-toastify";

const ModelTestRow = ({ row, mutate, onEditClick }) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    modelTestUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const { trigger: editTrigger } = useSWRMutation(
    modelTestUrls.editVisibility(row._id),
    sendPutRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the model test "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };

  const handleVisibilty = async (state) => {
    await editTrigger({ visible: state });
  };

  return (
    <>
      <TableRow key={row._id} link={`/admin/model-test/${row._id}`}>
        <TableData>{row.title}</TableData>
        <TableData>{row.price}</TableData>
        <TableData>{row.maxAttempts}</TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row)}
          onDelete={handleDelete}
          onToggle={(newState) => {
            handleVisibilty(newState);
          }}
          initialToggle={row.visible}
        />
      </TableRow>
    </>
  );
};

export default ModelTestRow;
